var fn = function( obj ){
var __t,__p='';
__p+='\n#if __VERSION__ == 300\n  #define IN in\n  #define OUT out\n#else\n  #define IN attribute\n  #define OUT varying\n#endif\n\n\nIN vec3 aPosition;\n\nuniform mat4 uM;\nuniform mat4 uVP;\n\n\n\nvoid main( void ){\n\n  gl_Position     = uVP * uM * vec4(aPosition, 1.0);\n\n}';
return __p;
};
fn.toString=fn;
module.exports = fn;